import { setupFormState } from '@/components/form/tidal-form'
import { DepotFormValues } from './types'

export const form = setupFormState<DepotFormValues>({
  id: 'depotForm',
  initialValues: {
    id: '',
    name: '',
    setupCost: 0,
    setupTime: 0,
    location: {
      address: '',
      geoAddress: '',
      latLng: { lat: 0, lng: 0 },
      rawLatLngAsString: '',
      source: 'MANUAL',
      status: 'OK',
    },
    color: '#fff',
  },
})
